import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Alert,
  CircularProgress
} from '@mui/material';
import { DeleteForever as DeleteForeverIcon } from '@mui/icons-material';
import api from '../services/api';
import { authService } from '../services/authService';

// Red "Удалить аккаунт" button + confirmation dialog.
// Used in respondent and client (customer) profiles, never for admins.
export default function DeleteAccountSection({ sx }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    if (deleting) return;
    setOpen(false);
    setError('');
  };

  const handleConfirm = async () => {
    setDeleting(true);
    setError('');
    try {
      await api.delete('/users/me');
    } catch (e) {
      setError(e?.response?.data?.error || 'Не удалось удалить аккаунт. Попробуйте ещё раз.');
      setDeleting(false);
      return;
    }

    // Same cleanup as a normal logout (incl. saved login/password), keeps only
    // the device push token so a new account on this phone still gets pushes.
    authService.logout();
    dispatch({ type: 'auth/logout' });
    setOpen(false);
    setDeleting(false);
    navigate('/login', { replace: true });
  };

  return (
    <Box sx={{ mt: 3, mx: { xs: 0, md: 3 }, ...sx }}>
      <Button
        variant="contained"
        color="error"
        startIcon={<DeleteForeverIcon />}
        onClick={() => setOpen(true)}
        sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '12px', px: 3, py: 1.2 }}
      >
        Удалить аккаунт
      </Button>

      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>
          Вы уверены, что хотите удалить аккаунт?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Все ваши данные будут удалены из Thinklink, пройденные опросы, накопленные баллы и BYN пропадут.
          </DialogContentText>
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, gap: 1, flexWrap: 'wrap' }}>
          <Button onClick={handleClose} disabled={deleting} sx={{ textTransform: 'none' }}>
            Нет, отмена
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleConfirm}
            disabled={deleting}
            startIcon={deleting ? <CircularProgress size={18} color="inherit" /> : null}
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Да, уверен
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
